import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { fnCallable, GetRecentInvoicesSummaryResponse } from '@fnModels/stripe';
import { Stripe } from 'stripe';

@Injectable({
	providedIn: 'root',
})
export class StripeService {
	constructor(private fns: AngularFireFunctions) {}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getBusinessBalance = (): Observable<any> => {
		const callable = this.fns.httpsCallable(
			fnCallable.stripeGetBusinessBalance,
		);

		return callable({});
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	createNewStripeCustomer = (businessId: string): Observable<any> => {
		const callable = this.fns.httpsCallable('createNewStripeCustomer');

		return callable({ businessId });
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getBillingPortalRedirectURL = (returnUrl: string): Observable<any> => {
		const callable = this.fns.httpsCallable(
			'getStripeBillingPortalRedirectURL',
		);

		return callable({ returnUrl });
	};

	updateBillingEmailAddress = (email: string) => {
		const callable = this.fns.httpsCallable(
			fnCallable.stripeUpdateBillingEmail,
		);

		return callable({ email });
	};

	getRecentInvoices = (params: Stripe.InvoiceListParams = { limit: 15 }) => {
		const callable = this.fns.httpsCallable(fnCallable.stripeGetRecentInvoices);

		return callable(params) as Observable<
			GetRecentInvoicesSummaryResponse<Stripe.Invoice>
		>;
	};
}
